import * as PIXI from "pixi.js";
import Game from "../Game";
import Layers from "../layers/Layers";
import SwapSprite from "../animation/SwapSprite";
import { Coord } from "../types/Interface";


export default class BaseGuideText extends PIXI.Text {
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();

  constructor(text: string, color: number, coord: Coord, yOffset = 0) {
    super();
    this.addCoord(coord, yOffset)
    this.addDetails(text, color);
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Info.addChild(this);
  setVisible(visible: boolean) {
    if (visible) {
      const onUpdate = (v: number) => this.scale.set(v);
      this.visible = true;
      this.scale.set(.5)
      new SwapSprite(.5, 1, (v: number) => onUpdate(v));
      return
    }
    this.visible = visible;
  }
  addCoord(coord: Coord, yOffset: number) {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      return Object.assign(this, coord);
    }
    this.x = dim.WIDTH / 2;
    this.y = 460 + yOffset;
    this.anchor.set(.5)
  }
  addDetails(text: string, color: number) {
    this.text = text;
    this.style.fill = color;
    this.style.fontWeight = "600";
    this.style.fontStyle = "italic";
    this.style.fontSize = 30;
  }
}